<script>
    import QuickInput from 'views/components/quickInput/QuickInput.svelte'
    import { parseGapInputAsNumber } from 'views/components/taskGroups/tasks/template41/GapTextUtil'

    let {
        value = $bindable(''),
    } = $props()

    let quickInput

    function onInput(inputString) {

        // Inform the user when the input is not a valid number
        if (inputString.length && inputString !== '-' && parseGapInputAsNumber(inputString).error) {
            Backbone.View.layout.openStatus(
                window.i18n.gettext('Enter a valid number.')
            )
            quickInput.setInvalidState()
        }

        value = inputString
    }
</script>

<QuickInput
    bind:this={quickInput}
    {value}
    inputMode="decimal"
    noAutoCapitalize={true}
    noAutoCorrect={true}
    displayInline={true}
    inputCallback={onInput}
></QuickInput>
